import { useContext, useEffect, useState } from 'react';
import { collection, query, onSnapshot } from "firebase/firestore";

import { db } from '../../firebase/firebase';
import AuthContext from '../../store/auth-context';



export const useGetAllUsers = () => {
    const [users, setUsers] = useState();

    const authCtx = useContext(AuthContext);

    useEffect(() => { 
        if(authCtx.currentUserId && authCtx.currentUserProfile.is_admin) {
            const myQuery = query(collection(db, 'users'));
            onSnapshot(myQuery, (querySnapshot) => {
                const allData = [];
                querySnapshot.forEach((doc) => {
                    allData.push({...doc.data(), id: doc.id});
                });
                setUsers(allData);
            }, (error) => {
                console.log('error from useGetAllUsers: ', error)
            });
        }   
    }, [authCtx.currentUserId, authCtx.is_admin]);

return users;
}; 

